/**
 * Strefy (zakładki) — progressive enhancement.
 *
 * Bez JS: menu jest bezczynne, a panele leżą w flow jeden pod drugim
 * (treść w pełni dostępna). Ten skrypt dodaje:
 *  - przełączanie paneli z przenikaniem (klasy is-active + CSS),
 *  - strzałkę wskazującą aktywną zakładkę (is-first-active na bloku;
 *    klik w strzałkę przełącza na drugą zakładkę),
 *  - role tab/tablist/tabpanel + ARIA i strzałki klawiatury — dopiero
 *    tutaj, bo bez działającego przełączania role by kłamały.
 */
(function () {
    var SEL_BLOCK = '.wp-block-avangardo-zones';
    var SEL_BTN = '.wp-block-avangardo-zones__menuBtn';
    var SEL_PANEL = '.wp-block-avangardo-zones__panel';
    var SEL_ARROW = '.wp-block-avangardo-zones__arrow';
    var SEL_MENU = '.wp-block-avangardo-zones__menu';

    function initBlock(block, blockIndex) {
        var menu = block.querySelector(SEL_MENU);
        var arrow = block.querySelector(SEL_ARROW);
        var buttons = Array.prototype.slice.call(block.querySelectorAll(SEL_BTN));
        var panels = Array.prototype.slice.call(block.querySelectorAll(SEL_PANEL));

        if (!menu || buttons.length < 2 || panels.length !== buttons.length) return;

        var current = 0;

        menu.setAttribute('role', 'tablist');
        buttons.forEach(function (btn, i) {
            var tabId = 'avZones-' + blockIndex + '-tab-' + i;
            var panelId = 'avZones-' + blockIndex + '-panel-' + i;
            btn.id = tabId;
            btn.setAttribute('role', 'tab');
            btn.setAttribute('aria-controls', panelId);
            panels[i].id = panelId;
            panels[i].setAttribute('role', 'tabpanel');
            panels[i].setAttribute('aria-labelledby', tabId);
            btn.addEventListener('click', function () {
                activate(i);
            });
        });

        function sync() {
            buttons.forEach(function (btn, i) {
                var active = i === current;
                btn.classList.toggle('is-active', active);
                btn.setAttribute('aria-selected', active ? 'true' : 'false');
                btn.tabIndex = active ? 0 : -1;
            });
            panels.forEach(function (panel, i) {
                panel.classList.toggle('is-active', i === current);
                panel.setAttribute('aria-hidden', i === current ? 'false' : 'true');
            });
            block.classList.toggle('is-first-active', current === 0);
        }

        function activate(i) {
            if (i === current || !panels[i]) return;
            current = i;
            sync();
        }

        if (arrow) {
            arrow.addEventListener('click', function () {
                activate(current === 0 ? 1 : 0);
            });
        }

        // roving tabindex: strzałki klawiatury przełączają zakładki
        menu.addEventListener('keydown', function (e) {
            if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
            var next = e.key === 'ArrowRight'
                ? Math.min(current + 1, buttons.length - 1)
                : Math.max(current - 1, 0);
            if (next !== current) {
                activate(next);
                buttons[next].focus();
            }
            e.preventDefault();
        });

        sync();
        // włącza CSS-owe sztaplowanie paneli i fade; przed tą klasą
        // panele leżą w flow (stan bez JS)
        block.classList.add('is-enhanced');
    }

    function init() {
        document.querySelectorAll(SEL_BLOCK).forEach(initBlock);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
